module.exports = __webpack_public_path__ + "static/media/Surface.05e1cbb1.svg";